import { useState, useEffect } from 'react'
import { useApp, type Modal } from '@/core/state/appStore'
import { getJourneyPosition } from '@/core/data/coachings'
import { AUFGABE } from '@/core/data/aufgabe'

export function useTabGating(): {
  disabledSubTabIds: Set<string>
  position: number | null
  aufgabeName: string | null
} {
  const { state } = useApp()
  const [journey, setJourney] = useState<{
    position: number | null
    aufgabeName: string | null
  }>({
    position: null,
    aufgabeName: null,
  })

  const skipVerbisLebenslauf =
    state.screen?.kind === 'verbis-lebenslauf' ||
    state.screen?.kind === 'aufnahme-potenzialanalyse' ||
    state.screen?.kind === 'kompetenzfeststellung' ||
    state.screen?.kind === 'kompetenzbilanzierung' ||
    state.screen?.kind === 'dokument' ||
    state.screen?.kind === 'dokument-hochladen'

  useEffect(() => {
    if (!state.screen?.coachingId || skipVerbisLebenslauf) {
      setJourney({ position: null, aufgabeName: null })
      return
    }
    let cancelled = false
    getJourneyPosition(state.screen?.coachingId)
      .then(({ position, aufgabeName }) => {
        if (!cancelled) setJourney({ position, aufgabeName })
      })
      .catch((e) => {
        console.error("Journey-Position (Tab-Gating) fehlgeschlagen:", e)
        if (!cancelled) setJourney({ position: null, aufgabeName: null })
      })
    return () => {
      cancelled = true
    }
  }, [state.screen?.coachingId, skipVerbisLebenslauf, state.screen?.tab, state.tbGenerating, state.dashboardVersion])

  const { position, aufgabeName } = journey
  const disabledSubTabIds = new Set<string>()

  const reached = (min: number) => position !== null && position >= min
  const modal = state.screen?.kind as Modal | null
  if (modal === 'avgs') {
    if (!reached(AUFGABE.stammdaten.position)) disabledSubTabIds.add('stammdaten')
    if (!reached(AUFGABE.avgsUpload.position)) disabledSubTabIds.add('upload')
    if (!reached(AUFGABE.avgsPruefen.position)) disabledSubTabIds.add('avgs')
    if (!reached(AUFGABE.tbHochladen.position)) disabledSubTabIds.add('tb-hochladen')
    if (!reached(AUFGABE.tbAusfuellen.position)) disabledSubTabIds.add('bestaetigung')
  }
  if (modal === 'bewilligung') {
    if (!reached(AUFGABE.bewilligungPruefen.position)) disabledSubTabIds.add('bewilligung')
  }
  if (modal === 'abschluss') {
    if (!reached(AUFGABE.abschlussberichtPruefen.position)) disabledSubTabIds.add('pruefen')
    if (!reached(AUFGABE.teilnehmendenlistePruefen.position)) disabledSubTabIds.add('teilnehmendenliste')
    if (!reached(AUFGABE.zertifikatPruefen.position)) disabledSubTabIds.add('zertifikat')
  }

  return { disabledSubTabIds, position, aufgabeName }
}
